import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axios from "axios";

import { ApplicationFormPrepared } from "@/lib/prisma";

export function getApplicationForm(
  applicationId: string,
  formInstanceId: string
): Promise<ApplicationFormPrepared> {
  return axios
    .get(`/api/application/${applicationId}/form/${formInstanceId}`)
    .then((res) => res.data);
}
export function useApplicationForm(
  applicationId: string,
  formInstanceId?: string,
  options: UseQueryOptions<any, any, any, any> = {}
) {
  return useQuery<ApplicationFormPrepared | null>(
    ["application-form-query", applicationId, formInstanceId],
    async () =>
      applicationId && formInstanceId
        ? await getApplicationForm(applicationId, formInstanceId)
        : null,
    {
      refetchOnWindowFocus: false,
      enabled: !!formInstanceId,
      ...options,
    }
  );
}
